import axios from "axios";
import { API_URL } from "../utils/constants";

const getServiceLocale = async (country, serviceId) => {
  return axios.get(
    `/${country.code}${API_URL}/locale/all?service=${serviceId}`
  );
};

export default getServiceLocale;
